import { AppStrings } from "../../../utils/constants/AppStrings";
import { getLanguageDisplayName } from "../../../utils/i18n/languagePreference";
import { FE_SUPPORTED_LANGUAGE_OPTIONS } from "../../../utils/i18n/availableLanguages";
import Select from "../Select/Select";
import { getLanguageFlag } from "./languageFlags";
import "./stylesLanguageSelect.css";

export type LanguageSelectProps = {
  value: string;
  onChange: (lng: string) => void;
  /** Locale codes to list. Defaults to the full FE-supported set. */
  options?: string[];
  disabled?: boolean;
  className?: string;
  id?: string;
  "data-testid"?: string;
};

function LanguageOptionLabel({ lng }: { lng: string }) {
  return (
    <span className="language-select-option">
      <span className="language-select-flag" aria-hidden="true">
        {getLanguageFlag(lng)}
      </span>
      <span>{getLanguageDisplayName(lng)}</span>
    </span>
  );
}

/**
 * Shared language dropdown used on Login (guest) and Header (admin).
 * Parents own persistence + reload; this only renders the Select.
 */
function LanguageSelect({
  value,
  onChange,
  options = FE_SUPPORTED_LANGUAGE_OPTIONS,
  disabled = false,
  className = "",
  id,
  "data-testid": testId = "language-select",
}: LanguageSelectProps) {
  return (
    <Select
      id={id}
      className={className}
      classNames={{ popup: { root: "language-select-dropdown" } }}
      aria-label={AppStrings.LANGUAGE_SELECTOR_LABEL}
      data-testid={testId}
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={options.map((lng) => ({
        value: lng,
        label: <LanguageOptionLabel lng={lng} />,
      }))}
      // Keep the dropdown inside the parent so popovers (Header profile)
      // don't dismiss on mousedown outside their ref.
      getPopupContainer={(trigger) => trigger.parentElement}
    />
  );
}

export default LanguageSelect;
